var map = {
	"./audiomonitor_1.png": 964,
	"./audiomonitor_2.png": 719,
	"./cloudproject_1.png": 542,
	"./dfa_1.png": 695,
	"./homemonitor_1.png": 75,
	"./homemonitor_2.png": 99,
	"./homemonitor_3.png": 446,
	"./nucleorecorder_1.png": 227,
	"./nucleorecorder_2.png": 733,
	"./robot_1.png": 884,
	"./robot_2.png": 608,
	"./robot_3.png": 58,
	"./simon_1.png": 44,
	"./simon_2.png": 933,
	"./sonoff_1.png": 112,
	"./sonoff_2.png": 967,
	"./sonoff_3.png": 216,
	"./soundmeter_1.png": 748,
	"./sunshine_1.png": 285,
	"./sunshine_2.png": 73,
	"./sunshine_3.png": 131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 882;